import { render, staticRenderFns } from "./spaceChart.vue?vue&type=template&id=a098ab54&"
import script from "./spaceChart.vue?vue&type=script&lang=js&"
export * from "./spaceChart.vue?vue&type=script&lang=js&"
import style0 from "./spaceChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports